<template>
  <transition name="modal">

    <!-- New Modal -->
    <div class="modal-overlay" style="opacity: 1.09; display: block;">
      <div class="modal-wrapper showSweetAlert visible" data-custom-class="" data-has-cancel-button="true" data-has-confirm-button="true" data-allow-outside-click="false" data-has-done-function="true" data-animation="pop" data-timer="null" style="display: block; margin-top: -191px;">
        <spinner v-if="isLoading"></spinner>
        <errors v-if="isVisibleErrorsModal"></errors>
        <div class="modal-close col-sm-12 text-right">
          <button class="modal-button" @click="closeModal()"><span class="icon-close"></span></button>
        </div>

        <header class="modal-header">
          <h2 class="modal-title ">Add payment method</h2>
        </header>

        <div class="modal-body mt-lg">
            <slot name="body">
              <p class="modal-paragraph">
                  Please select check or wire/ACH as an option:
              </p>
              <fieldset class="row pt-lg">
                <div class="col-md-6">
                  <div v-bind:class="fundingSourceType === fundingSourceTypes.CHECK.name ? 'radio-item' : 'radio-item radio-item-unselected'">
                    <input id="checkOption"
                      name="checkOption"
                      type="radio"
                      v-bind:value="fundingSourceTypes.CHECK.name"
                      v-model="fundingSourceType" />
                    <label for="checkOption">{{ fundingSourceTypes.CHECK.label }}</label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div v-bind:class="fundingSourceType === fundingSourceTypes.WIRE_TRANSFER.name ? 'radio-item' : 'radio-item radio-item-unselected right-margin'">
                    <input id="wireTransferOption"
                      name="wireTransferOption"
                      type="radio"
                      v-bind:value="fundingSourceTypes.WIRE_TRANSFER.name"
                      v-model="fundingSourceType" />
                    <label for="wireTransferOption">{{ fundingSourceTypes.WIRE_TRANSFER.label }}</label>
                  </div>
                </div>
            </fieldset>
            </slot>
          </div>

          <div class="modal-buttons">
            <slot name="body">
              <div class="row">
                <div class="col-md-12 text-right">
                  <button type="submit" class="btn btn-info btn-lg btn-cancel" @click="closeModal()">Cancel</button>
                  <button type="submit" class="btn btn-info btn-lg btn-save" @click="saveModal()">Save</button>
                </div>
              </div>
            </slot>
          </div>
      </div>
    </div>
    <!-- End of New Modal -->
  </transition>
</template>

<script>
  import {
    mapMutations,
    mapActions,
    mapState,
  } from 'vuex';
  import {
    HIDE_CHECK_WIRE_MODAL,
    SET_ERRORS_MODAL_INFO,
    SHOW_ERRORS_MODAL,
    SET_CREATION_SUCCEEDED,
  } from '@/store/mutation-types';

  import { find } from 'lodash';

  import { formatDate, formatAmount, formatType, formatStatus } from '@/util';
  import spinner from '@/components/widgets/Spinner';
  import Errors from '@/components/modals/Errors';

  const mix = {
    methods: {
      formatDate,
      formatAmount,
      formatType,
      formatStatus,
    },
  };

  export default {
    name: 'checkWire',
    beforeMount() {
      this.fundingSourceType = this.fundingSourceTypes.CHECK.name;
    },
    props: ['closeAction'],
    mixins: [mix],
    components: {
      errors: Errors,
      spinner,
    },
    computed: {
      ...mapState('app', [
        'fundingSourceTypes',
      ]),
      ...mapState('checkWireModal', [
        'accountId',
        'fundingSources',
      ]),
      ...mapState('errors', [
        'isVisibleErrorsModal',
      ]),
    },
    data() {
      return {
        fundingSourceType: 'check',
        isLoading: false,
      };
    },
    methods: {
      ...mapActions('checkWireModal', [
        'createAccountFundingSources',
      ]),
      ...mapMutations('checkWireModal', {
        hideCheckWireModal: HIDE_CHECK_WIRE_MODAL,
        setCreationStatus: SET_CREATION_SUCCEEDED,
      }),
      ...mapMutations('errors', {
        showErrorsModal: SHOW_ERRORS_MODAL,
        setErrorsModalInfo: SET_ERRORS_MODAL_INFO,
      }),
      async saveModal() {
        try {
          this.isLoading = true;
          let fundingSourceKey = ''
;
          const containsFundingSourceType = find(this.fundingSources,
                fs => fs.type === this.fundingSourceType && !fs.removed);
          if (containsFundingSourceType) {
            this.setErrorsModalInfo([`Please note that ${formatType(this.fundingSourceType, 'investor')}
          already exists as a bank account. Try adding a different type of bank account.`]);
            this.showErrorsModal();
            this.isLoading = false;
            return;
          }
          if (this.fundingSourceType.includes('check')) {
            fundingSourceKey = 'CHECK';
          } else if (this.fundingSourceType.includes('wire')) {
            fundingSourceKey = 'WIRE_TRANSFER';
          }
          await this.createAccountFundingSources({
            accountId: this.accountId,
            payload: {
              type: fundingSourceKey,
            },
          });
          this.isLoading = false;
          this.setCreationStatus(true);
          this.hideCheckWireModal();
          this.closeAction();
        } catch (error) {
          this.isLoading = false;
          this.setCreationStatus(false);
          if (error !== 'UNAUTHORIZED') {
            this.setErrorsModalInfo(['We could not save the bank account']);
            this.showErrorsModal();
          }
        }
      },
      closeModal() {
        this.setCreationStatus(false);
        this.hideCheckWireModal();
        if (typeof this.closeAction === 'function') {
          this.closeAction();
        }
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .radio-item {
    display: inline-block;
    position: relative;
    padding: 0 6px;
  }
  .radio-item input[type='radio'] {
    display: none;
  }
  .radio-item label {
    color: #666;
    font-weight: normal;
    cursor: pointer;
  }
  .radio-item label:before {
    content: " ";
    display: inline-block;
    position: relative;
    top: 5px;
    left: 0px;
    margin: 0 20px 0 0;
    width: 20px;
    height: 20px;
    border-radius: 11px;
    background-color: transparent;
  }
  .radio-item-unselected label:before {
    content: " ";
    display: inline-block;
    position: relative;
    top: 5px;
    left: 0px;
    margin: 0 20px 0 0;
    width: 20px;
    height: 20px;
    border-radius: 11px;
    background-color: transparent;
    border: 2px solid #d3d3d3;
  }
  .radio-item input[type=radio]:checked+label:after {
    border-radius: 11px;
    width: 10px;
    height: 10px;
    position: absolute;
    top: 10px;
    left: 11px;
    content: " ";
    display: block;
  }
</style>



// WEBPACK FOOTER //
// CheckWireTransfer.vue?c93e3c88